<template>
    <div class="m-travel">
        <div class="t-slider">
            <div class="t-search-box">
                <van-search
                    v-model="search"
                    shape="round"
                    placeholder="超级周末/姑婆山/三娘湾/爱情童话"
                />
            </div>
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(topnav,index) in swiperdata" :key="index" style="height:200px;">
                    <a :href="topnav.url"><img :src="topnav.img" width="100%" /></a>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="m-nav">
            <router-link to="/travel" v-for="(nav,index) in navs" :key="index">
                <div class="icon" @click="scrollto(nav.element)">
                    <img :src="nav.icon" alt="">
                </div>
                <div class="name" @click="scrollto(nav.element)">{{nav.name}}<div class="line n1"></div></div>
            </router-link>        
        </div>
        <div class="m-column-floor-1">
            <h2 class="common-head">
                <span>
                    <img class="t1" src="../../assets/images/travel/title_1.png" alt="">
                </span>
                <router-link to="/gxnews/more/24747"></router-link>
            </h2>
            <div class="travel-news-list">
                <swiper :options="swiperOption">
                  <swiper-slide v-for="(wlitem,index) in wenlvdata" :key="index">
                        <div class="list">
                            <a :href="wlitem.url">
                                <div class="pic">
                                    <img :src="wlitem.img" alt="">
                                </div>
                                <div class="title">{{wlitem.title}}</div>
                            </a>
                        </div>
                    </swiper-slide>
                </swiper>                
            </div>
            <div class="m-activity">
                <h3 class="common-title">
                    <div class="top-box">活动大本营<div class="line"></div></div>
                </h3>
                <div class="slider-activity">
                    <van-swipe :autoplay="3000">
                        <van-swipe-item v-for="(huodong,index) in huodongdata" :key="index">
                            <dl>
                            <a :href="huodong.url">
                                <dt v-if="huodong.imageid!='0'">
                                    <img :src="huodong.img" alt="">    
                                </dt>
                                <dd>
                                    <p class="title">{{huodong.title}}</p>
                                    <p class="content">
                                        {{huodong.description}}
                                    </p>
                                </dd>
                            </a>
                            </dl>
                        </van-swipe-item>
                        
                    </van-swipe>
                </div>
                <div class="m-ad">
                    <a href="http://sub.gxnews.com.cn/subject/2020/gxrygx/index.html">
                        <img src="../../assets/images/travel/travel_banner_ad.png" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="m-column-floor-2">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_2.png" alt="">
                </span>
                <router-link to="/gxnews/more/51370"></router-link>
            </h2>
            <div class="online-list">
                <h3 class="common-title">
                    <div class="top-box">新时代网红孵化基地<div class="line"></div></div>
                </h3>
                <swiper :options="swiperOptionUser">
                   <swiper-slide v-for="(wanghong,index) in wanghongdata" :key="index">
                        <div class="list">
                            <a :href="wanghong.url">
                                <div class="pic">
                                    <img :src="wanghong.img" alt="">    
                                </div>
                                <div class="name">{{wanghong.title}}</div>
                            </a>
                        </div>
                   </swiper-slide>
                   
                </swiper>
            </div>
            <div class="live-coming">
                <h3 class="common-title">
                    <div class="top-box">
                        直播来啦<div class="line"></div>
                    </div>                   
                </h3>
                <swiper :options="swiperOptionLive">
                    <swiper-slide v-for="(live,index) in livedata" :key="index">
                        <div class="list">
                            <a :href="live.url">
                                <img :src="live.img" alt="">
                            </a>
                        </div>
                    </swiper-slide>
                    
                </swiper>   
            </div>
            <div class="vlog-list">
                <h3 class="common-title">
                    <div class="top-box">
                        嗨vlog<div class="line"></div>
                    </div>
                </h3> 
                <swiper :options="swiperOptionPlay">
                    <swiper-slide v-for="(hivlog,index) in hivlogdata" :key="index">
                        <div class="list">
                            <a :href="hivlog.url">
                                <div class="pic">
                                    <img :src="hivlog.img" alt="">    
                                </div>
                                <div class="name">{{hivlog.title}}</div>
                            </a>    
                        </div>
                    </swiper-slide>
                </swiper>  
            </div>
        </div>
        <div class="m-column-floor-3">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_3.png" alt="">
                </span>
                <router-link to="/gxnews/more/24748"></router-link>
            </h2>
            <ul>
                <li v-for="(qing,index) in jieqingdata" :key="index">
                    <a :href="qing.url">
                        <div class="pic">
                            <img :src="qing.img" alt="">    
                        </div>
                        <div class="name">{{qing.title}}</div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="m-column-floor-4">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_4.png" alt="">
                </span>
                <router-link to="/gxnews/more/24760"></router-link>
            </h2>
            <div class="c-floor-list">
                <swiper :options="swiperOptionGood">
                    <swiper-slide v-for="(foods,index) in foodsdata" :key="index">
                        <div class="list" v-if="foods.imageid!='0'">
                            <a :href="foods.url">
                                <img :src="foods.img" alt="">
                            </a>    
                        </div>
                    </swiper-slide>
                </swiper>
            </div>            
            <div class="c-floor-news chengwei">
                <h3 class="common-title">
                    <div class="top-box">为你读书<div class="line"></div></div>
                </h3>
                <ul>
                    <li v-for="(cw,index) in chengweidata" :key="index">
                        <a :href="cw.url">                            
                            <div class="pic">
                                <i class="play"></i>
                                <img :src="cw.img" alt="">    
                            </div>
                            <div class="name">{{cw.title}}</div>
                        </a>
                    </li>
                </ul>            
            </div>
        </div>
        <div class="m-column-floor-5">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_5.png" alt="">
                </span>
                <router-link to="/gxnews/more/51315"></router-link>
            </h2>
            <ul class="c-floor-list">
                <li v-for="(travellog,index) in travellogdata" :key="index">
                    <a :href="travellog.url">
                        <div class="pic">
                            <img :src="travellog.img" alt="">    
                        </div>
                        <div class="name"><em>热门</em>{{travellog.title}}</div>
                    </a>    
                </li>
            </ul>
            <div class="c-floor-news">
                <h3 class="common-title">
                    <div class="top-box">酷游分享<div class="line"></div></div>
                </h3>
                <swiper :options="swiperOptionTour">
                    <swiper-slide v-for="(cool,index) in cooldata" :key="index">
                        <div class="list">
                            <a :href="cool.url">
                                <div class="pic">
                                    <img :src="cool.img" alt="">    
                                </div>
                                <div class="name">{{cool.title}}</div>
                            </a>    
                        </div>
                    </swiper-slide> 
                </swiper>
            </div>
        </div>
        <div class="m-column-floor-6">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_6.png" alt="">
                </span>
                <router-link to="/travel"></router-link>
            </h2>
            <div class="c-slider">
                <van-swipe :autoplay="3000">
                    <van-swipe-item>
                        <div class="list">
                            <img src="../../assets/images/travel/pic_1.jpg" alt="">
                            <router-link to="/travel" class="inst-txt">
                                <div class="title">广西龙胜龙脊梯田绿波荡漾 壮美云海景观</div>
                                <div class="content">在大家印象中，印度尼西亚的巴厘岛，泰国的普吉岛，都是著名的旅游岛，但是因为电影……</div>
                            </router-link>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="list">
                            <img src="../../assets/images/travel/pic_1.jpg" alt="">
                            <router-link to="/travel" class="inst-txt">
                                <div class="title">广西龙胜龙脊梯田绿波荡漾 壮美云海景观</div>
                                <div class="content">在大家印象中，印度尼西亚的巴厘岛，泰国的普吉岛，都是著名的旅游岛，但是因为电影……</div>
                            </router-link>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="list">
                            <img src="../../assets/images/travel/pic_1.jpg" alt="">
                            <router-link to="/travel" class="inst-txt">
                                <div class="title">广西龙胜龙脊梯田绿波荡漾 壮美云海景观</div>
                                <div class="content">在大家印象中，印度尼西亚的巴厘岛，泰国的普吉岛，都是著名的旅游岛，但是因为电影……</div>
                            </router-link>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="m-column-floor-7">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_7.png" alt="">
                </span>
                <router-link to="/gxnews/more/47137"></router-link>
            </h2>
            <div class="c-slider">
                <van-swipe :autoplay="3000">
                    <van-swipe-item v-for="(quanjing,index) in quanjingdata" :key="index">
                        <div class="list">
                            <a :href="quanjing.url">
                                <div class="pic">
                                    <img :src="quanjing.img" alt="">    
                                </div>
                                <div class="title">{{quanjing.title}}</div>
                                <div class="content">{{quanjing.description}}</div>
                            </a>
                        </div>
                    </van-swipe-item>
                    
                </van-swipe>   
            </div>
        </div>
        <div class="m-column-floor-8">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_8.png" alt="">
                </span>
                <router-link to="/travel"></router-link>
            </h2>
            <div class="c-slider">
                <swiper :options="swiperOptionTour">
                    <swiper-slide>
                        <div class="list">
                            <router-link to="/travel">
                                <div class="pic">
                                    <i class="play-ico"></i>
                                    <img src="../../assets/images/travel/pic_3.jpg" alt="">    
                                </div>
                                <div class="name">广西壮族自治区成立60周年 漫游新广西</div>
                            </router-link>    
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <router-link to="/travel">
                                <div class="pic">
                                    <i class="play-ico"></i>
                                    <img src="../../assets/images/travel/pic_3.jpg" alt="">    
                                </div>
                                <div class="name">广西壮族自治区成立60周年 漫游新广西</div>
                            </router-link>    
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <router-link to="/travel">
                                <div class="pic">
                                    <i class="play-ico"></i>
                                    <img src="../../assets/images/travel/pic_3.jpg" alt="">    
                                </div>
                                <div class="name">广西壮族自治区成立60周年 漫游新广西</div>
                            </router-link>    
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <router-link to="/travel">
                                <div class="pic">
                                    <i class="play-ico"></i>
                                    <img src="../../assets/images/travel/pic_3.jpg" alt="">    
                                </div>
                                <div class="name">广西壮族自治区成立60周年 漫游新广西</div>
                            </router-link>    
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <router-link to="/travel">                                
                                <div class="pic">
                                    <i class="play-ico"></i>
                                    <img src="../../assets/images/travel/pic_3.jpg" alt="">    
                                </div>
                                <div class="name">广西壮族自治区成立60周年 漫游新广西</div>
                            </router-link>    
                        </div>
                    </swiper-slide>
                </swiper>
            </div>            
        </div>
        <div class="m-column-floor-9">
            <h2 class="common-head">
                <span>
                    <img src="../../assets/images/travel/title_9.png" alt="">
                </span>
                <router-link to="/gxnews/more/24747"></router-link>
            </h2>
            <div class="reading-list">
                <dl v-for="(item,index) in readingdata" :key="index">
                    <dt>
                        <a :href="item.url">
                            <div class="title">
                                <span v-if="item.enclitic">H5</span>
                                {{item.title}}
                            </div>
                            <div class="from">{{item.source}}<span>{{item.humantime}}</span></div>
                        </a>    
                    </dt>
                    <dd v-if="item.img">
                        <img :src="item.img" alt="">
                    </dd>
                </dl>
                
                <!--<div class="get-more">
                    下滑查看更多
                    <i class="hand"></i>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import jsonp from 'jsonp'
    import 'vant/lib/index.css'
    import 'swiper/dist/css/swiper.css'
    import {swiper , swiperSlide} from 'vue-awesome-swiper'

    export default {
        data(){
            return{
                search:'',
                //文旅新鲜报
                swiperOption:{
                    slidesPerView: 2.7
                },
                //网红孵化基地
                swiperOptionUser:{
                    slidesPerView: 3.5
                },
                //直播来了
                swiperOptionLive:{
                    slidesPerView: 2.2
                },
                //嗨vlog
                swiperOptionPlay:{
                    slidesPerView: 2.2
                },
                //寻味广西
                swiperOptionGood:{
                    slidesPerView: 3.2
                },
                //酷游分享
                swiperOptionTour:{
                    slidesPerView: 2.2
                },
                navs:[
                    {icon: require('../../assets/images/travel/nav_ico_1.png'), name: '直播广西', element:'.m-column-floor-2'},
                    {icon: require('../../assets/images/travel/nav_ico_2.png'), name: '节庆广西', element:'.m-column-floor-3'},
                    {icon: require('../../assets/images/travel/nav_ico_3.png'), name: '寻味广西', element:'.m-column-floor-4'},
                    {icon: require('../../assets/images/travel/nav_ico_4.png'), name: '旅游日历', element:'.m-column-floor-5'},
                    {icon: require('../../assets/images/travel/nav_ico_5.png'), name: 'VR+旅游',  element:'.m-column-floor-7'},
                    {icon: require('../../assets/images/travel/nav_ico_6.png'), name: '图说广西', element:'.m-column-floor-6'},
                ],
                swiperdata:[],
                wenlvdata:[],
                huodongdata:[],
                wanghongdata:[],
                livedata:[],
                hivlogdata:[],
                jieqingdata:[],
                foodsdata:[],
                chengweidata:[],
                travellogdata:[],
                cooldata:[],
                quanjingdata:[],
                readingdata:[],
            }    
        },
        created(){

        },
        mounted(){
            
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51354&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("swiperdata",data);
                    this.swiperdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=24747&start=0&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("wenlvdata",data);
                    this.wenlvdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=24832&start=0&limit=4', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("huodongdata",data);
                    this.huodongdata = data;
                }
            })

            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51370&start=0&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("wanghongdata",data);
                    this.wanghongdata = data;
                }
            })

            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=45129&start=0&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("zhibo",data);
                    this.livedata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=44820&start=0&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("hivlog",data);
                    this.hivlogdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=24748&start=0&limit=2', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("jieqing",data);
                    this.jieqingdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=24760&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("foods",data);
                    this.foodsdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51315&start=0&limit=2', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("travellog",data);
                    this.travellogdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51316&start=0&limit=4', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("cool",data);
                    this.cooldata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=47137&start=0&limit=4', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("quanjing",data);
                    this.quanjingdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=24747&start=5&limit=10', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("readingdata",data);
                    this.readingdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51580&start=0&limit=2', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("chengweidata",data);
                    this.chengweidata = data;
                }
            })
            
        },
        components:{
            swiper, 
            swiperSlide
        },
        methods: {
            scrollto(element){
                $('html, body').animate({
                    scrollTop: $(element).offset().top
                }, 2000);
            }
        }    
    }
</script>

<style lang="less">
    /*公共样式*/
    .van-swipe__indicator{
        opacity: 1;
    }
    .common-head{
        display: flex;
        padding: 0 0.6rem;
        margin-bottom: 0.3rem;
        span,a{
            flex: 1;
        }
        img{
            width: 70%;
            display: block;
        }
        .t1{
            width: 100%;
        }
        a{
            background: url("../../assets/images/travel/more.png") right center no-repeat;
            background-size: 30%;        
        }
    }
    .common-title{
        text-align: center;
        margin-bottom: 0.4rem;        
        .top-box{
            font-size: 0.36rem;
            color: #000;
            position: relative;
            display: inline-block;
            padding: 0 0.2rem;
        }
        .line{
            position: absolute;
            width: 100%;
            height: 0.3rem;
            left: 0;
            bottom: 0.03rem;
            background: #c6edff;
            z-index: -1;
            border-radius: 1rem;
        }
    }
    .m-nav{
        overflow: hidden;
        padding-bottom: 0.45rem;
        border-bottom: 0.3rem solid #f1f1f1;
        a{
            display: block;
            width: 33.3%;
            float: left;
            text-align: center;
            padding-top: 0.5rem;
            font-size: 0.35rem;
            color: #000;
            img{
                width: 25%;
            }
        }
        .icon{
            height: 1.08rem;
        }
        .name{
            position: relative;
            width: 50%;
            display: inline-block;
            .line{
                width: 100%;
                height: 0.16rem;
                position: absolute;
                left: 0;
                top: 0.25rem;
                z-index: -1;
            }
            .n1{
                background: #c6edff;
            }
            .n2{
                background: #cac6ff;
            }
            .n3{
                background: #c6ffed;
            }
            .n4{
                background: #ffc6da;
            }
            .n5{
                background: #ecffb3;
            }
            .n6{
                background: #c6ffcf;
            }
        }
    }
    /*-----------------*/
    .t-slider{
        position: relative;
    }
    .t-search-box{
        position: absolute;
        left: 8%;
        top: 0.3rem;
        z-index: 10;
        width: 85%;
        .van-search{
            padding: 0;
            border-radius: 1rem;
        }
    }
    .m-column-floor-1{
        padding-top: 0.45rem;
        .travel-news-list{
            background: #f6f6f6;
            padding: 0.4rem 0 0.4rem 0.35rem;
            overflow: hidden;
            .list{
                width: 3.33rem;
                height: 4.06rem;
                box-sizing: border-box;
                padding: 0.3rem 0.25rem;
                float: left;
                background: #fff;
                box-shadow: 0 0 0.6rem #eeeded; 
                //margin-left: 0.4rem;
                .pic{
                    height: 1.6rem;
                    overflow: hidden;
                    img{
                        width: 100%;
                    }
                }
                .title{
                    margin-top: 0.15rem;
                    font-size: 0.35rem;
                    color: #333;
                }
                .check{
                    margin-top: 0.1rem;
                    text-align: center;
                    img{
                        width: 65%;
                    }
                }
            }
        }
        .m-activity{
            padding: 0.45rem 0.35rem;
            border-bottom: 0.3rem solid #f1f1f1;
        }
        .slider-activity{
            padding-right: 0.1rem;
            dl{
                overflow: hidden;
                padding-bottom: 0.7rem;
            }
            dt{
                width: 4.05rem;
                height: 3.8rem;
                float: left;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            dd{
                padding-left: 4.4rem;
                .title{
                    color: #000;
                    font-size: 0.42rem;
                    font-weight: bold;
                    margin-bottom: 0.15rem;
                }
                .content{
                    color: #929292;
                    font-size: 0.32rem;
                    height:80px;
                    overflow: hidden;
                }
            }
        }
        .m-ad{
            img{
                width: 100%;
            }
        }
    }
    .m-column-floor-2{
        padding: 0.45rem 0;
        border-bottom: 0.3rem solid #f1f1f1;
        .online-list{
            padding: 0.4rem 0;
            overflow: hidden;
            .list{
                width: 100%;
                text-align: center;
                img{
                    width: 85%;
                    border-radius: 50%;
                }
                .pic{
                    margin-bottom: 0.1rem;
                }
                .name{
                    font-size: 0.35rem;
                    color: #000;
                }
            }
        }
        .live-coming{
            padding: 0.4rem 0 0.35rem 0.35rem;
            .list{
                width: 100%;
                img{
                    width: 90%;
                    border-radius: 0.4rem;
                }
            }
        }
        .vlog-list{
            padding: 0.6rem 0 0.35rem 0.35rem;
            .list{
                width: 90%;
                img{
                    width: 100%;
                    height:5rem;
                }
                .pic{
                    margin-bottom: 0.15rem;
                }
                .name{
                    font-size: 0.36rem;
                    color: #000;
                }
            }     
        }   
    }
    .m-column-floor-3{
        padding: 0.45rem 0;
        border-bottom: 0.3rem solid #f1f1f1;
        ul{
            overflow: hidden;
        }
        li{
            float: left;
            width: 50%;
            box-sizing: border-box;
            padding: 0 0.3rem;
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
            .pic{
                margin-bottom: 0.15rem;
            }
            .name{
                font-size: 0.36rem;
                color: #000;
            }
        }    
    }
    .m-column-floor-4{
        padding: 0.55rem 0;
        .c-floor-list{
            padding: 0.7rem 0 0.7rem 0.5rem;
            background: #f6f6f6;
            .list{
                margin-right: 0.35rem;
            }
            img{
                width: 100%;
                height: 2rem;
            }
        }
        .c-floor-news{
            margin-top: 0.5rem;
            ul{
                &:after{
                    content: '';
                    display: block;
                    clear: both;
                    visibility: hidden;
                    height: 0;
                }
            }
            li{
                float: left;
                width: 50%;
                box-sizing: border-box;
                padding: 0.2rem 0.3rem;
                img{
                    width: 100%;

                }
                a{
                    display: block;
                    padding: 0.22rem 0.3rem;
                    box-shadow: 0 0 0.3rem #ccc;
                    background: #fff;
                }                
                .pic{
                    position: relative;
                    margin-bottom: 0.15rem;
                }
                .play{
                    display: block;
                    position: absolute;
                    width: 0.7rem;
                    height: 0.7rem;
                    background: url("../../assets/images/travel/play_icon.png") no-repeat;
                    background-size: 100%;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
                .name{
                    font-size: 0.36rem;
                    color: #000;
                }
            }
            .more{
                margin-top: 0.4rem;
                padding: 0 0.3rem;
                a{
                    display: block;
                    height: 0.9rem;
                    line-height: 0.9rem;
                    text-align: center;
                    color: #ccc;
                    font-size: 0.38rem;
                    background: #f1f1f1;
                }
                .hand{
                    display: inline-block;
                    width: 0.5rem;
                    height: 0.56rem;
                    background: url("../../assets/images/travel/hand.png") no-repeat;
                    background-size: 100%;
                    vertical-align: middle;
                    margin-left: 0.05rem;
                }
            }
        }
    }
    .m-column-floor-5{
        padding: 0.55rem 0;
        .c-floor-list{
            &:after{
                content: '';
                display: block;
                clear: both;
                visibility: hidden;
                height: 0;
            }
            li{
                float: left;
                width: 50%;
                box-sizing: border-box;
                padding: 0.2rem 0.3rem;
                img{
                    width: 100%;
                }
                a{
                    display: block;
                    padding: 0.15rem 0.25rem;
                    box-shadow: 0 0 0.3rem #ccc;
                    background: #fff;
                } 
                .title{
                    font-size: 0.35rem;
                    color: #000;
                    margin-bottom: 0.05rem;
                    span{
                        font-size: 0.5rem;
                        font-weight: bold;
                    }
                }               
                .pic{
                    position: relative;
                    margin-bottom: 0.15rem;
                    max-height: 280px;
                    overflow: hidden;
                }
                .name{
                    font-size: 0.36rem;
                    color: #000;
                    height:1.6rem;
                    overflow: hidden;
                    em{
                        display: inline-block;
                        vertical-align: middle;
                        font-style: normal;
                        background: #59a0d8;
                        color: #fff;
                        font-size: 0.35rem;
                        padding: 0 0.1rem;
                        border-radius: 0.15rem;
                        margin-right: 0.15rem;
                    }
                }
            }
        }
        .c-floor-news{
            margin-top: 0.5rem;
            padding: 0.4rem 0 0.4rem 0.4rem;
            .list{
                margin-right: 0.35rem;
            }
            img{
                width: 100%;
                border-radius: 0.2rem;
                height: 4rem;
            }
            .name{
                font-size: 0.35rem;
                color: #333;
            }
        }      
    }
    .m-column-floor-6{
        display: none;
        padding-bottom: 0.7rem;
        .c-slider{
            margin-top: 0.5rem;
        }
        .list{
            position: relative;
            img{
                width: 100%;
            }
            a{
                position: absolute;
                width: 100%;
                left: 0;
                top: 0;
                text-align: center;
                font-size: 0.35rem;
                color: #fff;
                display: block;
                padding-top: 0.35rem;
            }
            .title{
                font-size: 0.6rem;
                padding: 0 1.3rem;
                font-weight: bold;
            }
            .content{
                padding: 0 1.3rem;
                margin-top: 0.3rem;    
            }
        }    
    }
    .m-column-floor-7{
        padding-bottom: 0.6rem;
        border-bottom: 0.3rem solid #f1f1f1;
        .c-slider{
            margin-top: 0.5rem;
            .list{
                position: relative;
                img{
                    width: 100%;
                }
                a{
                    font-size: 0.35rem;
                    color: #333;
                    display: block;
                    text-align: center;
                }
                .pic{
                    margin-bottom: 0.2rem;
                }
                .title{
                    font-size: 0.5rem;
                    font-weight: bold;
                }
                .content{
                    margin-top: 0.15rem;  
                    padding: 0 0.5rem;  
                }
            }
        }
    }
    .m-column-floor-8{
        display: none;
        padding: 0.6rem 0;
        border-bottom: 0.3rem solid #f1f1f1;
        .c-slider{
            margin-top: 0.5rem;
            padding-left: 0.4rem;
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
        }
        .list{
            margin-right: 0.35rem;
            position: relative;
        }
        .pic{
            position: relative;
        }
        .play-ico{
            display: block;
            position: absolute;
            width: 0.7rem;
            height: 0.7rem;
            background: url("../../assets/images/travel/play_icon.png") no-repeat;
            background-size: 100%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        .name{
            font-size: 0.35rem;
            color: #333;
        }
    }
    .m-column-floor-9{
        padding: 0.6rem 0 2rem 0;
        .reading-list{
            padding: 0.2rem 0.3rem 0 0.4rem;
            dl{
                overflow: hidden;
                margin-bottom: 0.45rem;
                padding-bottom: 0.4rem;
                border-bottom: 1px solid #d8d8d8;
            }
            dt{
                float: left;
                width: 65%;
                box-sizing: border-box;
                padding-right: 0.5rem;
                .title{
                    color: #000;
                    font-size: 0.42rem;
                    margin-bottom: 0.15rem;
                    span{
                        display: inline-block;
                        color: #fff;
                        vertical-align: middle;
                        padding: 0 0.15rem;
                        font-size: 0.35rem;
                        background: #58a1d8;
                        margin-right: 0.1rem;
                        border-radius: 0.1rem;
                    }
                }
                .from{
                    color: #929292;
                    font-size: 0.32rem;
                    margin-top: 0.2rem;
                }
            }
            dd{
                width: 35%;
                float: left;
                img{
                    width: 100%;
                    border-radius: 0.15rem;
                }
            }
            .get-more{
                padding: 0 0.3rem;
                display: block;
                height: 0.9rem;
                line-height: 0.9rem;
                text-align: center;
                color: #ccc;
                font-size: 0.38rem;
                background: #f1f1f1;
                .hand{
                    display: inline-block;
                    width: 0.5rem;
                    height: 0.56rem;
                    background: url("../../assets/images/travel/hand.png") no-repeat;
                    background-size: 100%;
                    vertical-align: middle;
                    margin-left: 0.05rem;
                }
            }
        }
    }
</style>